/**
 * FOLLOW C: bag always goes to /cart.
 * Horizon cart-drawer intercept is disabled so iPhone Safari cannot
 * land on a leftover PDP instead of the cart page.
 */

function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart.configure({
    eventTarget: () => document,
  });

  actions.openCart.configure({
    async handler() {
      window.location.assign('/cart');
    },
  });
}

if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}
